import { useState } from 'react';
import { ArrowUpRight, Check, ShieldCheck } from 'lucide-react';
import SectionHeading from './SectionHeading.jsx';
import {
  onlinePlans,
  personalTrainingPlans,
} from '../data/siteData.js';

function PriceCard({ plan }) {
  return (
    <article
      className={`price-card ${
        plan.popular ? 'price-card--popular' : ''
      }`}
    >
      {plan.popular ? (
        <span className="popular-badge">Legnépszerűbb</span>
      ) : null}

      <div className="price-card-header">
        <h3>{plan.name}</h3>
        <p>{plan.description}</p>
      </div>

      <div className="price-line">
        <strong>{plan.price}</strong>
        <span>{plan.unit}</span>
      </div>

      <ul>
        {plan.features.map((feature) => (
          <li key={feature}>
            <Check size={17} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <a
        className={`button ${
          plan.popular ? 'button--gold' : 'button--outline'
        } button--full`}
        href="#kapcsolat"
      >
        {plan.cta}
        <ArrowUpRight size={18} />
      </a>
    </article>
  );
}

export default function Pricing() {
  const [mode, setMode] = useState('personal');

  const plans =
    mode === 'personal' ? personalTrainingPlans : onlinePlans;

  return (
    <section className="section pricing-section" id="arak">
      <div className="pricing-glow" aria-hidden="true" />

      <div className="container">
        <SectionHeading
          eyebrow="Árak és csomagok"
          title="Átlátható árak. Rejtett költségek nélkül."
          text="Válaszd ki a célodhoz és az életviteledhez legjobban illő szolgáltatást. Minden program személyre szabott, átlátható és szakmai támogatással készül."
          align="center"
        />

        <div
          className="pricing-toggle"
          role="group"
          aria-label="Ártípus kiválasztása"
        >
          <button
            className={mode === 'personal' ? 'active' : ''}
            type="button"
            onClick={() => setMode('personal')}
          >
            Személyi edzés
          </button>

          <button
            className={mode === 'online' ? 'active' : ''}
            type="button"
            onClick={() => setMode('online')}
          >
            Online coaching
          </button>
        </div>

        <div className="pricing-grid">
          {plans.map((plan) => (
            <PriceCard plan={plan} key={plan.name} />
          ))}
        </div>

        <div className="consultation-box">
          <div className="consultation-content">
            <span className="consultation-eyebrow">
              Nem tudod, melyiket válaszd?
            </span>

            <h3>15 perces ingyenes konzultáció</h3>

            <p>
              Röviden átbeszéljük a céljaidat, az edzésmúltadat,
              az időbeosztásodat és azt, hogy melyik szolgáltatás lenne
              számodra a legjobb választás.
            </p>
          </div>

          <a className="button button--gold" href="#kapcsolat">
            Ingyenes konzultációt kérek
            <ArrowUpRight size={18} />
          </a>
        </div>

        <div className="price-note">
          <ShieldCheck size={20} />

          <p>
            A konzultáció ingyenes és nem kötelez vásárlásra. Egészségügyi
            probléma vagy sérülés esetén a közös munka megkezdése előtt
            orvosi vagy gyógytornászi jóváhagyásra lehet szükség.
          </p>
        </div>
      </div>
    </section>
  );
}